export default __webpack_public_path__ + "static/media/StudentManagement.1ee1d440.gif";